import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import { CheckCircle, ContentCopy, OpenInNew } from '@mui/icons-material';

export default function SubmissionConfirmation({
  submissionResult,
  type,
  referenceText,
  userEmail,
  copied,
  onCopyReference,
}) {
  return (
    <Box sx={{ py: 3, textAlign: 'center' }}>
      <CheckCircle sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />
      <Typography variant="h5" fontWeight={800} gutterBottom>
        Thank You!
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Your {type === 'feature' ? 'feature request' : 'issue report'} has been received by our engineering team.
      </Typography>

      {/* Reference Number Box */}
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 1.5,
          bgcolor: 'grey.100',
          px: 3,
          py: 1.5,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'grey.300',
          mb: 3,
        }}
      >
        <Typography variant="subtitle1" fontWeight={700} color="text.primary">
          Reference: {referenceText}
        </Typography>
        <Tooltip title={copied ? 'Copied!' : 'Copy Reference'}>
          <IconButton
            size="small"
            aria-label="Copy reference number"
            onClick={() => onCopyReference(referenceText)}
            color={copied ? 'success' : 'default'}
          >
            <ContentCopy fontSize="small" />
          </IconButton>
        </Tooltip>
        {submissionResult?.issueUrl && (
          <Tooltip title="View on GitHub">
            <IconButton
              size="small"
              component="a"
              href={submissionResult.issueUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="View on GitHub"
              color="primary"
            >
              <OpenInNew fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>

      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420, mx: 'auto' }}>
        We have dispatched a confirmation email to <strong>{userEmail || 'your email'}</strong>. Our team will review this report shortly.
      </Typography>
    </Box>
  );
}
